var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 25,
    r: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5954 8V28H39.1908C39.1908 39.0629 31.2901 48 21.5954 48V28H4C4 16.9371 11.9008 8 21.5954 8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.916 28C34.916 36.3731 28.9618 43.141 21.5954 43.141V28H8.2748C8.2748 19.6269 14.229 12.859 21.5954 12.859V28H34.916Z",
    fill: "#008100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6412 28C30.6412 33.6833 26.5954 38.282 21.5954 38.282V28H12.5496C12.5496 22.3167 16.5954 17.718 21.5954 17.718V28H30.6412Z",
    fill: "#0461AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 25.8308V9.47507C22.6641 9.128 22.7786 8.82431 22.9695 8.56401C23.1603 8.3037 23.4275 8.21693 23.7328 8.21693H28.4656C28.771 8.21693 29.0763 8.34709 29.3435 8.56401C29.6107 8.82431 29.8015 9.08461 29.8779 9.43168L33.313 20.6681L36.7481 9.43168C36.8244 9.08461 37.0153 8.78093 37.2824 8.56401C37.5496 8.3037 37.855 8.21693 38.1603 8.21693H42.9313C43.2366 8.21693 43.5038 8.34709 43.6947 8.56401C43.8855 8.82431 44 9.128 44 9.47507V25.8308C44 26.1779 43.8855 26.4816 43.6947 26.7419C43.4656 27.0022 43.1985 27.089 42.8931 27.089H40.7557C40.4504 27.089 40.1832 26.9588 39.9542 26.7419C39.7252 26.525 39.6107 26.2213 39.6107 25.8308V12.9458L35.5267 25.8742C35.4122 26.2213 35.2214 26.4816 34.9542 26.6985C34.687 26.9154 34.3817 27.0456 34.1145 27.0456H32.4733C32.1679 27.0456 31.9008 26.9154 31.6336 26.6985C31.3664 26.4816 31.1756 26.1779 31.0611 25.8742L26.9771 12.9458V25.8308C26.9771 26.1779 26.8626 26.4816 26.6718 26.7419C26.4427 27.0022 26.1756 27.089 25.8702 27.089H23.7328C23.4275 27.089 23.1603 26.9588 22.9313 26.7419C22.7023 26.525 22.5878 26.2213 22.5878 25.8308H22.6641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6031 37.9783C16.3664 37.8481 12.9695 33.9436 12.855 29.1714H20.6031V37.9783Z",
    fill: "#D42435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 8,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.895b1485a33c820f9fe000ffb20e5a00.svg";
export { ForwardRef as ReactComponent };